//http://localhost:3000/getsurveydata/65545f0aeafd1e146ff23f165619e75d
//http://localhost:3000/getsurveydata/0fa09057aa37dbca634cb777a7bc1acc
//survey_token = 65545f0aeafd1e146ff23f165619e75d para prueba
//localhost:3000/getsurveydata/48518a4c6193d29dd149a74348464712  (produccion)
//localhost:3000/getsurveydata/2b9fc96807170e24bfce6d0f5d48967e   (local)
import React, { Component } from 'react';
import * as $ from 'jquery';
import SurveyHeader from '../SurveyHeader.js';
import SurveyFooter from '../SurveyFooter.js';
import EncuestaGeneral from './EncuestaGeneral.js';
import GraciasSurvey from './GraciasSurvey.js';
import axios from 'axios'; //llamar WS
import brandLogo from '../../images/brand-logo-dark.png';
import { Redirect, withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import { translate } from 'react-i18next'; //esp/eng

let cancelToken;

const APARTADO = {
  ENCUESTA: 1,
  GRACIAS: 2
}; 

class GetSurveyDataContainer extends Component {

  constructor(props) {
    super(props);
    this.state = this.getInitState(); 
  }

  componentWillMount() {
    cancelToken = axios.CancelToken.source();
    survey_token: this.props.match.params.survey_token;
  }

  componentDidMount() {
    this.getSurveyData({
      token_id: this.props.getTokenId(),
      token_session: this.props.getTokenSession(),
      survey_token: this.props.match.params.survey_token
    });
  }  

  reload = () => {
    this.getSurveyData({
      token_id: this.props.getTokenId(),
      token_session: this.props.getTokenSession(),
      survey_token: this.props.match.params.survey_token
    });
  }

  renderSurveyHeader = () => {
    return(<SurveyHeader />);
  }

  renderSurveyFooter = () => {
    return(<SurveyFooter />);
  }

  renderEncuestaGeneral = () => {
    return(
      <EncuestaGeneral
      handleQuestionsForm={this.handleQuestionsForm}
      activarBoton={this.activarBoton}
      encuesta={this.state.encuesta}
      />
     
    );
  }

  renderGraciasSurvey = () => {
    return(<GraciasSurvey 
        encuesta={this.state.encuesta}
      />);
  }
 
  getInitState = () => {
    return({
      encuesta: null,
      categoria_id:null
    });
  }

  getSurveyData = (params) => {
    this.props.post(
      "/getSurveyData",
      params,
      (response) => this.didGetSurvey(response),
      (error) => this.props.handleErrorResponse(error),
      cancelToken
    );
  }

  didGetSurvey = (response) => {
    this.setState({
      encuesta: response
    }, this.scrollTop);
  }

/* ----- enviar formulario ---- */
 handleQuestionsForm = (event) => {
    //this.getAnswers();
    event.preventDefault();
    this.sendSurvey({
      //id: this.state.survey.id,
      data: this.props.match.params.data,
      questions: this.getAnswers(),
      token_id: this.props.getTokenId(),
      token_session: this.props.getTokenSession()
    }); 
  }

/* activar boton Escalar tipo8 */
 activarBoton = (event) => {
    let valor = event.target.innerText;
    let pregunta_id = event.target.getAttribute('name');
    $('#boton0_'+pregunta_id).removeClass('rb-tab-active');
    $('#boton1_'+pregunta_id).removeClass('rb-tab-active');
    $('#boton2_'+pregunta_id).removeClass('rb-tab-active');
    $('#boton3_'+pregunta_id).removeClass('rb-tab-active');
    $('#boton4_'+pregunta_id).removeClass('rb-tab-active');
    $('#boton5_'+pregunta_id).removeClass('rb-tab-active');
    $('#boton6_'+pregunta_id).removeClass('rb-tab-active');
    $('#boton7_'+pregunta_id).removeClass('rb-tab-active');
    $('#boton8_'+pregunta_id).removeClass('rb-tab-active');
    $('#boton9_'+pregunta_id).removeClass('rb-tab-active');
    $('#boton10_'+pregunta_id).removeClass('rb-tab-active');
    $('#boton'+valor+'_'+pregunta_id).addClass('rb-tab-active');
    if(pregunta_id){
      document.getElementById(pregunta_id).value = valor;
    }    
  }

  getAnswers = () => {
    const answers = [];
    let x=0;
      this.state.encuesta.categoria.forEach((categoria) =>
        categoria.pregunta.forEach((pregunta) => {

          switch(pregunta.tipo_pregunta){
            case "1": // 1 - Opcion Multiple
              answers.push({
                id:x,
                encuesta_id: this.state.encuesta.id,
                //CON2-9027 al guardar las preguntas ahora la categoria se obtiene de pregunta.encuesta_categoria_id
                //categoria_id: categoria.id,
                categoria_id: pregunta.encuesta_categoria_id,
                pregunta_id: pregunta.id,
                value: $("input[name='" + pregunta.id + "']:checked").val(),
                comments: "",
                tipo_pregunta: pregunta.tipo_pregunta,
                obligatoria: pregunta.obligatoria
              });
              x++;              
            break;
            case "2": // 2 - Abierta  
              answers.push({
                id:x,
                encuesta_id: this.state.encuesta.id,
                //categoria_id: categoria.id,
                categoria_id: pregunta.encuesta_categoria_id,
                pregunta_id: pregunta.id,
                value: "",
                comments: $("input[name='" + pregunta.id + "']").val(),
                tipo_pregunta: pregunta.tipo_pregunta,
                obligatoria: pregunta.obligatoria
              });
              x++; 
              break;
            case "3": // 3 - Menú Desplegable
              var e = document.getElementById(pregunta.id);
              var seleccionada = e.options[e.selectedIndex].value;
              answers.push({
                id:x,
                encuesta_id: this.state.encuesta.id,
                //categoria_id: categoria.id,
                categoria_id: pregunta.encuesta_categoria_id,
                pregunta_id: pregunta.id,
                value: seleccionada,
                comments: "",
                tipo_pregunta: pregunta.tipo_pregunta,
                obligatoria: pregunta.obligatoria
              });
              x++;              
            break;  
            case "5": // 5 - Cuadros de verificación
              pregunta.opciones.forEach((opciones) => {
                seleccionada = $("input[name='" + opciones.id + "']:checked").val()
                if(seleccionada){
                    answers.push({
                      id:x,
                      encuesta_id: this.state.encuesta.id,
                      //categoria_id: categoria.id,
                      categoria_id: pregunta.encuesta_categoria_id,
                      pregunta_id: pregunta.id,
                      value: $("input[name='" + opciones.id + "']:checked").val(),
                      comments: "",
                      tipo_pregunta: pregunta.tipo_pregunta,
                      obligatoria: pregunta.obligatoria
                    });
                    x++;                   
                }
              })
            break;
            case "7": // 7 -Net Promoter Score 
              answers.push({
                id:x,
                encuesta_id: this.state.encuesta.id,
                //categoria_id: categoria.id,
                categoria_id: pregunta.encuesta_categoria_id,
                pregunta_id: pregunta.id,
                value: $("input[name='" + pregunta.id + "']").val(),
                comments: "",
                tipo_pregunta: pregunta.tipo_pregunta,
                obligatoria: pregunta.obligatoria
              });
              x++; 
              break; 
            case "8": // 2 - ESCALA  
              answers.push({
                id:x,
                encuesta_id: this.state.encuesta.id,
                //categoria_id: categoria.id,
                categoria_id: pregunta.encuesta_categoria_id,
                pregunta_id: pregunta.id,
                value: $("input[name='" + pregunta.id + "']").val(),
                comments: "",
                tipo_pregunta: pregunta.tipo_pregunta,
                obligatoria: pregunta.obligatoria
              });
              x++; 
              break;
          }
        })
      );
      console.log("answers---->",answers);
    return answers;
  }

  sendSurvey = (params) => {


    this.props.post(
      "/saveSurvey",
      params,
      (response) => this.didSendSurvey(response),
      (error) => this.props.handleErrorResponse(error),
      cancelToken
    );
  }

  didSendSurvey = () => {
    //mostrar agradecimiento por contestar la encuesta
    $('#preguntasSurvey').addClass('hidden');
    $('#graciasSurvey').removeClass('hidden'); 
  }  
/* ----- enviar formulario ----- */
  render() {
    return(
      <div className="encuestan_get_Suvery_data">
        {this.renderSurveyHeader()}
          <div className="container-fluid" >
            {this.renderEncuestaGeneral()}
          </div>
          
        {this.renderGraciasSurvey()}
        {this.renderSurveyFooter()}
        
      </div>
    );
  }
}

export default compose(
  translate('common'),
  withRouter
)(GetSurveyDataContainer);


// WEBPACK FOOTER //
// ./src/guest/GetSurveyData/GetSurveyDataContainer.js